// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rel-position{
    position: relative;
  }
  .abs-position{
    position:absolute;
    left: 650px
  }
  .todo-mini{
    font-size: 14px;
    font-weight: 600;
    color: #2c2b2bed;
}

.urgent-post{
  color: red;
}
.edit-form .form-control{
  /* transition: none; */
  border: 1px solid #ccc;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
   width: 100%;
 }
 .edit-form .btn{
   background-color: #009345;
   color:aliceblue; 
   width: 25px;
   height: 30px;
   border-radius: 3px !important;
 }
 .createrid{
  font-size: 10px;
  /* font-weight: 700px; */
  color: black;
 }
  .position-abs{
  position:relative;
  left: 101px;

 } 
 .list-users input{
  height: 24px;
  }
  .users-container button{
    border: none;
    padding: 4px 10px 4px;
  }
  .tag-font{
    color: #7a7a7aed;
    font-size: 15px;
    text-shadow: 0 0 black;
  }
  .users-container .scrollableMain{
  overflow-x: hidden;
  }
 .small{
  font-size: 12px !important;
 }
 .todocomment{
  font-size: 14px;
 }
 .post-time{
  font-size: 10px;
}
.todo-mini{
color:#373535ed;
font-size: 12px;
}
.scrollableMini {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(67vh - 170px);
}
.custm-checkbox1 {
  width: 16px;
  height: 16px;
  border-radius: 50% !important;
  border: solid 3px #009933 !important;
}
.popup-component {
  visibility: hidden;
}
.popup-placeholder {
  width: 200px;
  height: 50px;
}
.posttime{
  font-size: 15PX;
  color: #000000d1 !important;
    text-shadow: 0 0 black;
}
.update-position{
  position:relative;
           left: 37px;
}
.complete{
  text-decoration: line-through;
  
}

.miniposition-abs{
  position: relative;
  left: 152px;
}
.position1-abs{
  position: relative;
  left: 127px;
}
.add-input{
  /* width: 450px; */
  max-width: 100%;
}
.green-icon{
  position: relative;
}
.green-icon span{
  position: absolute;
  right: -4px;
  top: 0px;
  color: white;
  background-color: red;
  width: 12px;
  height: 11px;
  border-radius: 100%;
  text-align: center;
  font-size:8px;
}

.button-icon {
  font-size: 22px;
  color: #9b9b9b;
  padding-left: 5px;
}
.green-border {
  border: 3px solid green;
  width: 20px;
  height: 20px;
}

.selectbox1{
  width: 270px;
}
.selectbox{
  width: 270px;
}
.copyMoveModal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  overflow-y: hidden;
}

.modal-content1 {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px 5px 20px 5px;
  border: 1px solid #888;
  width: 80%;
  max-width: 400px;
  position: relative;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.minitodo{
  width: 25px;
   height: 19px;
}

.taskAssign {
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers content horizontally */
}

.users-container {
  /* display: flex;
  flex-wrap: wrap;
  justify-content: center;  */
  gap: 10px; 
}

.list-users {
  border: 1px solid #ccc; /* Add border to each list item */
  border-radius: 5px; /* Optional: add border-radius for rounded corners */
  /* width: 370px;  */
}
.custm-checkbox1:checked{
  background-color: #009933 !important;
}
.img-upload{
 width: 30px;
 height: 25px;
}
@media screen and (max-width: 1440px) {
  .abs-position{
    position:absolute;
    left: 405px
  }
} 
@media screen and (min-width: 1440px) {
  .abs-position{
    position:absolute;
    left: 661px
  }
}
@media screen and (max-width:375px){
  .abs-position{
    position:absolute;
    left: 203px
  }
  .list-users-font{
    font-size: 14px;
  }
}
@media screen and (min-width:376px) and (max-width:438px) {
  .abs-position{
    position:absolute;
    left: 250px
  }
  .list-users-font{
    font-size: 14px;
  }
}
@media screen and (min-width:439px) and (max-width:576px) {
  .abs-position{
    position:absolute;
    left: 317px
  }
}
@media screen and (max-width:576px){
  .img-upload{
    width: 20px;
    height: 20px;
   }
  .minitodo-dd{
    padding-left: 81px;
  }
  .checkbox-pl{
   margin: 0px !important;
  }
  .checkbox-ml{
    margin-left: 14px !important;
  }
  .posttime{
    font-size: 12px;
  }
  .tag-font{
    font-size: 12px;
  }
}
@media screen and (min-width:576px) and (max-width:1200px) {
  .checkbox-pl{
    margin: 0px !important;
    padding-right: 0px;
   }
   .checkbox-ml{
    margin-left: 14px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/todos/MiniTodos.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qEAAqE;GACpE,WAAW;CACb;CACA;GACE,yBAAyB;GACzB,eAAe;GACf,WAAW;GACX,YAAY;GACZ,6BAA6B;CAC/B;CACA;EACC,eAAe;EACf,wBAAwB;EACxB,YAAY;CACb;EACC;EACA,iBAAiB;EACjB,WAAW;;CAEZ;CACA;EACC,YAAY;EACZ;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,sBAAsB;EACxB;EACA;EACA,kBAAkB;EAClB;CACD;EACC,0BAA0B;CAC3B;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;AACjB;AACA;AACA,eAAe;AACf,eAAe;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,2BAA2B;IACzB,sBAAsB;AAC1B;AACA;EACE,iBAAiB;WACR,UAAU;AACrB;AACA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;GACV,YAAY;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE;;6BAE2B;EAC3B,SAAS;AACX;;AAEA;EACE,sBAAsB,EAAE,iCAAiC;EACzD,kBAAkB,EAAE,oDAAoD;EACxE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;EACE;IACE,iBAAiB;IACjB;EACF;AACF;AACA;EACE;IACE,iBAAiB;IACjB;EACF;AACF;AACA;EACE;IACE,iBAAiB;IACjB;EACF;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB;EACF;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB;EACF;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;GACb;EACD;IACE,kBAAkB;EACpB;EACA;GACC,sBAAsB;EACvB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;GACnB;GACA;IACC,4BAA4B;EAC9B;AACF","sourcesContent":[".rel-position{\n    position: relative;\n  }\n  .abs-position{\n    position:absolute;\n    left: 650px\n  }\n  .todo-mini{\n    font-size: 14px;\n    font-weight: 600;\n    color: #2c2b2bed;\n}\n\n.urgent-post{\n  color: red;\n}\n.edit-form .form-control{\n  /* transition: none; */\n  border: 1px solid #ccc;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n   width: 100%;\n }\n .edit-form .btn{\n   background-color: #009345;\n   color:aliceblue; \n   width: 25px;\n   height: 30px;\n   border-radius: 3px !important;\n }\n .createrid{\n  font-size: 10px;\n  /* font-weight: 700px; */\n  color: black;\n }\n  .position-abs{\n  position:relative;\n  left: 101px;\n\n } \n .list-users input{\n  height: 24px;\n  }\n  .users-container button{\n    border: none;\n    padding: 4px 10px 4px;\n  }\n  .tag-font{\n    color: #7a7a7aed;\n    font-size: 15px;\n    text-shadow: 0 0 black;\n  }\n  .users-container .scrollableMain{\n  overflow-x: hidden;\n  }\n .small{\n  font-size: 12px !important;\n }\n .todocomment{\n  font-size: 14px;\n }\n .post-time{\n  font-size: 10px;\n}\n.todo-mini{\ncolor:#373535ed;\nfont-size: 12px;\n}\n.scrollableMini {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: calc(67vh - 170px);\n}\n.custm-checkbox1 {\n  width: 16px;\n  height: 16px;\n  border-radius: 50% !important;\n  border: solid 3px #009933 !important;\n}\n.popup-component {\n  visibility: hidden;\n}\n.popup-placeholder {\n  width: 200px;\n  height: 50px;\n}\n.posttime{\n  font-size: 15PX;\n  color: #000000d1 !important;\n    text-shadow: 0 0 black;\n}\n.update-position{\n  position:relative;\n           left: 37px;\n}\n.complete{\n  text-decoration: line-through;\n  \n}\n\n.miniposition-abs{\n  position: relative;\n  left: 152px;\n}\n.position1-abs{\n  position: relative;\n  left: 127px;\n}\n.add-input{\n  /* width: 450px; */\n  max-width: 100%;\n}\n.green-icon{\n  position: relative;\n}\n.green-icon span{\n  position: absolute;\n  right: -4px;\n  top: 0px;\n  color: white;\n  background-color: red;\n  width: 12px;\n  height: 11px;\n  border-radius: 100%;\n  text-align: center;\n  font-size:8px;\n}\n\n.button-icon {\n  font-size: 22px;\n  color: #9b9b9b;\n  padding-left: 5px;\n}\n.green-border {\n  border: 3px solid green;\n  width: 20px;\n  height: 20px;\n}\n\n.selectbox1{\n  width: 270px;\n}\n.selectbox{\n  width: 270px;\n}\n.copyMoveModal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.4);\n  overflow-y: hidden;\n}\n\n.modal-content1 {\n  background-color: #fefefe;\n  margin: 15% auto;\n  padding: 20px 5px 20px 5px;\n  border: 1px solid #888;\n  width: 80%;\n  max-width: 400px;\n  position: relative;\n}\n\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n.minitodo{\n  width: 25px;\n   height: 19px;\n}\n\n.taskAssign {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Centers content horizontally */\n}\n\n.users-container {\n  /* display: flex;\n  flex-wrap: wrap;\n  justify-content: center;  */\n  gap: 10px; \n}\n\n.list-users {\n  border: 1px solid #ccc; /* Add border to each list item */\n  border-radius: 5px; /* Optional: add border-radius for rounded corners */\n  /* width: 370px;  */\n}\n.custm-checkbox1:checked{\n  background-color: #009933 !important;\n}\n.img-upload{\n width: 30px;\n height: 25px;\n}\n@media screen and (max-width: 1440px) {\n  .abs-position{\n    position:absolute;\n    left: 405px\n  }\n} \n@media screen and (min-width: 1440px) {\n  .abs-position{\n    position:absolute;\n    left: 661px\n  }\n}\n@media screen and (max-width:375px){\n  .abs-position{\n    position:absolute;\n    left: 203px\n  }\n  .list-users-font{\n    font-size: 14px;\n  }\n}\n@media screen and (min-width:376px) and (max-width:438px) {\n  .abs-position{\n    position:absolute;\n    left: 250px\n  }\n  .list-users-font{\n    font-size: 14px;\n  }\n}\n@media screen and (min-width:439px) and (max-width:576px) {\n  .abs-position{\n    position:absolute;\n    left: 317px\n  }\n}\n@media screen and (max-width:576px){\n  .img-upload{\n    width: 20px;\n    height: 20px;\n   }\n  .minitodo-dd{\n    padding-left: 81px;\n  }\n  .checkbox-pl{\n   margin: 0px !important;\n  }\n  .checkbox-ml{\n    margin-left: 14px !important;\n  }\n  .posttime{\n    font-size: 12px;\n  }\n  .tag-font{\n    font-size: 12px;\n  }\n}\n@media screen and (min-width:576px) and (max-width:1200px) {\n  .checkbox-pl{\n    margin: 0px !important;\n    padding-right: 0px;\n   }\n   .checkbox-ml{\n    margin-left: 14px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
